/**
 * Class with methods to authentication.
 *
 */

import { DefaultRequest } from 'scripts/api';

Monet.Authentication = {

    loginEl: null,

    showError: function (errorMessage) {
        $.toast({
            message: Monet.I18n.getResourcesByKey(errorMessage),
            displayTime: 5000,
            inTime: 100,
            outTime: 400,
            vPosition: "center",
            hPosition: "center"
        });
    },

    showSuccess: function (errorMessage) {
        $.toast({
            message: errorMessage,
            displayTime: 5000,
            inTime: 100,
            outTime: 400,
            vPosition: "center",
            hPosition: "center",
            className: "toastSuccess"
        });
    },

    setAppconfigurations: function (data, callback, callbackError) {

        var rMaps = new App.Routers.RouteMonitor();

        // Se não tiver sido configurada ainda, volta pra tela de login
        // e mostra um toast informando o problema
        if (!data[0]) {

            Monet.Session.isLogged = false;

            this.showError("GlobalConfiguration is not configured");

            if(callbackError){
                callbackError();
            }

        } else {

            Monet.Session.Configurations = data[0];
            Greenmile.Datepicker.LocationFormat();

            //Recupera os dados da MapConfiguration
            const request = new DefaultRequest({
                url: 'MapConfiguration',
                success: function (data) {

                    var mapConfiguration = new App.Collections.MapConfigurations();
                    mapConfiguration.add(data);
                    Monet.Session.Configurations.MapConfiguration = mapConfiguration;

                    if (callback) {

                        callback();
                    }

                }
            });
            request.send();

            this.changeUrl(rMaps);

        }

    },

    removeMetabaseCookieOnLogout: function () {
        const ajax = new Monet.Ajax();
        ajax.url = "/analytics/api/session/";
        ajax.method = 'DELETE';
        ajax.send();
    },

    logout: function (shouldShowTimeoutLogoffNotice) {
        if(Monet.Session.isLogged) {
            const request = new DefaultRequest({
                url: "logout?redirect=true",
                method: "get",
                success: function (data) {   
                    Monet.Session.isLogged = false;
                    if(window.greenmiletimeoutId) {
                        clearTimeout(window.greenmiletimeoutId);
                        window.greenmiletimeoutId = null;
                    }
                    if(window.greenmileIntervalId) {
                        clearInterval(window.greenmileIntervalId);
                        window.greenmileIntervalId = null;
                    }
                    if(window.greenmileLogoffTimeoutId) {
                        clearInterval(window.greenmileLogoffTimeoutId);
                        window.greenmileLogoffTimeoutId = null;
                    }
                    if(window.greenmileLogoutIntervalId) {
                        clearInterval(window.greenmileLogoutIntervalId);
                        window.greenmileLogoutIntervalId = null;
                    }

                    const { 
                        auth: { 
                            actions : { 
                                logout, showTimeoutLogoffNotice 
                            } 
                        },
                        logoffAlertModal: {
                            actions : {
                                closeModal
                            }
                        }
                    } = window.actions;
                    const logoffNoticeModalIsOpen = window.GreenmileReduxStore.getState().logoffAlertModal.get('isOpen')

                    if(data){
                        const url = data.logoutRedirectUrl; 
                        window.location.href = url;
                    }  else {
                        Monet.Authentication.redirectWithSlash();
                        window.GreenmileReduxStore.dispatch({ type: logout });
                        Greenmile.LoadAllSessionInfo.removeLogoutTimeoutListeners()

                        if(shouldShowTimeoutLogoffNotice) {
                            window.GreenmileReduxStore.dispatch({ type: showTimeoutLogoffNotice });
                        }
    
                        if(logoffNoticeModalIsOpen) {
                            window.GreenmileReduxStore.dispatch({ type: closeModal });
                        }
                    }
                },
                error: (err) => {
                    console.error(err);
                }
                
            });
            request.send();
        }
    },

    logoutMdlp: function () {
        if(Monet.Session.isLogged) {
            const request = new DefaultRequest({
                url: "logout?redirect=false",
                method: "get",
                success: function (data) {
                    Monet.Session.isLogged = false;
                    const { 
                        auth: { 
                            actions : { logout }
                        },

                    } = window.actions;

                    if(data){
                        const url = data.logoutRedirectUrl;
                        window.location.href = url;
                    } else {
                        window.GreenmileReduxStore.dispatch({ type: logout });
                        Greenmile.LoadAllSessionInfo.removeLogoutTimeoutListeners();
                    }

                }
                
            });
            request.send();
        }
    },

    redirectWithSlash: function(){
        window.location.href = window.location.href.split("#")[0] + '#/login';
    },

    redirectAfterLogin: function (url) {
        if(sessionStorage){
            sessionStorage.setItem("redirectTo", url);
        }
    },

    redirectLogin: function(xhr){
        this.hideLoading();
        if(this.usernameEl){
            this.usernameEl.focus();
        }
        if(xhr.status === 403){
            var url = window.location.href.split("#");
            if(url[1] && !url[1].includes("/RecoverPassword")) {
                this.redirectAfterLogin(url[1]);
                window.location.href = url[0];
            }
        }else{
            var error = new Monet.Exception.ReturnError(xhr, "Error[" + xhr.status + "] - " + xhr.statusText);
            error.console();
        }
    }
};
